import { msg } from "@lingui/core/macro";

export const durationMinimumRuleMessages = {
	name: msg({ message: "Duration Minimum" }),
	description: msg({ message: "Permit must have a minimum duration" }),
	errors: {
		tooShort: msg({ message: "Permit must have a duration longer than {minDurationInMinutes} minutes" }),
	},
} as const;
